import { featureFlags } from 'owa-feature-flags';

const addinsFeatureFlagsPrefix = 'addin';

export default function getEnabledAddinsFeatureFlags(): string[] {
    const enabledFeatureFlags = [];

    featureFlags.forEach((isEnabled: boolean, featureName: string) => {
        if (featureName.indexOf(addinsFeatureFlagsPrefix) === 0 && isEnabled) {
            enabledFeatureFlags.push(featureName);
        }
    });

    return enabledFeatureFlags.sort();
}
